import { useTRPC } from '../trpc/client';
import { Invoice, Merchant } from '../types';
import { useQuery } from '@tanstack/react-query';

// TODO: Move PDF download to backend and stream to client
export const usePdfDownload = (invoice: Invoice, merchant: Merchant, onError?: () => void) => {
  const trpc = useTRPC();
  
  const queryOptions = trpc.invoices.getPdf.queryOptions({
    rentalsMerchantId: merchant.id,
    id: invoice.id,
  });
  
  const userPDF = useQuery({
    ...queryOptions,
    enabled: false,
  });

  const downloadPdf = async () => {
    const downloadUrl = (await userPDF.refetch()).data;
    if (!downloadUrl) return onError?.();

    window.open(downloadUrl, '_blank');
  };

  return { downloadPdf };
};
